<template>
    <div class="product-promotion">
        <DefSliderWrapper>
            <swiper
                :modules="modules"
                :slides-per-view="1"
                :space-between="4"
                :pagination="{ clickable: true }"
            >
                <swiper-slide
                    v-for="item in result"
                    :key="item.id"
                >
                    <div class="product-promotion__item">
                        <DefImg :result="item.picture"/>
                        <p class="product-promotion__text">
                            {{ messages.inAction }}
                            <DefLink :href="item.detailPage">{{ item.name }}</DefLink>
                        </p>
                    </div>
                </swiper-slide>
            </swiper>
        </DefSliderWrapper>
    </div>
</template>

<script>
import DefImg from "../def/DefImg/DefImg";
import DefLink from "../def/DefLink/DefLink";

import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
    name: 'ProductPromotion',
    props: ['result', 'messages'],
    components: {
        DefImg,
        DefLink,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            settings: {},
            modules: [Pagination],
        }
    }
}
</script>

<style lang="scss" scoped>
.product-promotion {
    @include point-md{
        margin-top: -12px;
        margin-bottom: 12px;
    }
    &__item {
        display: grid;
        grid-template-columns: 54px 1fr;
        grid-column-gap: 10px;
        align-items: center;
        padding: 8px;
        background-color: var(--background-colour-primary);
        //margin-bottom: 24px;
    }

    &__text {
        text-transform: uppercase;
        font-size: rem(12);
        line-height: 125%;
    }

    :deep(.def-slider__container) {
        margin-bottom: 0;
    }

    :deep(.def-slider .swiper-pagination) {
        bottom: 10px;
    }
    :deep{
        .def-slider-wrapper .swiper-pagination{
            margin-top: 8px;
        }
        .def-slider-wrapper .swiper-pagination-bullet{
            width: 8px;
            height: 8px;
            &:not(:last-child){
                margin-right: 8px;
            }
        }
    }
}
</style>